import { Box, Stack } from "@mui/material";

import { ChatMessageWithParts } from "src/views/assistant/types";
import DialogueActions from "src/views/assistant/components/header/DialogueActions";

type PartsAIHeaderProps = {
  dialogueId: number | null;
  onNewChat: () => void;
  dialogue: ChatMessageWithParts[];
};

const PartsAIHeader = ({
  dialogueId,
  onNewChat,
  dialogue,
}: PartsAIHeaderProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={{ xs: 2, sm: 4, md: 6, xl: 8 }}
      sx={{
        px: 2,
        width: "100%",
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
        <span style={{ fontWeight: 600, fontSize: "1.1rem" }}>Parts AI</span>
      </Box>

      <Box
        sx={{ flexShrink: 0, display: "flex", alignItems: "center", gap: 2 }}
      >
        <DialogueActions
          dialogueId={dialogueId}
          onNewChat={onNewChat}
          dialogue={dialogue}
        />
      </Box>
    </Stack>
  );
};

export default PartsAIHeader;
